import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import {
  GetActualOpeningTimesDocument,
  GetHonorificBlockTimesQueryVariables,
  HealthProviderAvailable,
} from '../../types/api/graphql';

// get block times of honorific
export function useOpeningHoursItems(
  variables: GetHonorificBlockTimesQueryVariables,
  skip?: boolean
) {
  const { data: openingHoursItemsData, loading: openingHoursItemsLoading } =
    useQuery(GetActualOpeningTimesDocument, {
      variables: {
        ...variables,
      },
      skip: skip ?? !variables.healthProviderId,
    });

  const data = useMemo(
    () =>
      openingHoursItemsData?.healthProviderActualOpeningTimes as HealthProviderAvailable[],
    [openingHoursItemsData]
  );

  return {
    data,
    loading: openingHoursItemsLoading,
  };
}
